"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defineAppConfig_1 = require("../defineAppConfig");
exports.default = (0, defineAppConfig_1.defineAppConfig)({
    appName: 'Digital SDP',
    organizationId: 'uoyj5diUfVw9Sd7d2dGT',
    applicationKey: 'sdp',
    applicationType: 'organization',
    artistId: undefined,
    ionicAppId: 'deab7b82',
    platform: ['web', 'native'],
    ios: {
        bundleId: 'com.utoniq.sdp',
        appId: '1617203744',
    },
    android: {
        bundleId: 'com.utoniq.sdp',
    },
    deeplinkUrl: 'https://www.digital-sdp.com',
    helpUrl: 'https://help.utoniq.com/ja/collections/3562292',
    dynamicLinkPrefix: 'digitalsdp',
    applink: 'sdp.utoniq.com',
    deeplinkProd: 'www.digital-sdp.com',
    custom: {
        modules: {
            trade: true,
            membership: true,
            prepaidPoint: { chargeable: true },
            gacha: true,
            item: true,
            store: true,
            mission: true,
            konbiniPayment: true,
        },
        tutorials: [
            'images/tutorial/Tutorial01.jpg',
            'images/tutorial/Tutorial02.jpg',
            'images/tutorial/Tutorial03.jpg',
        ],
        globalTabs: ['home', 'notifications', 'artist', 'myProfile'],
        artistTabs: ['home', 'collections', 'store', 'gachas', 'trade'],
    },
});
